"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _DOMAIN = 'my-contributions/';
exports.default = {
  GET_PENDING_INIT: _DOMAIN + 'GET_PENDING_INIT',
  GET_PENDING_SUCCESS: _DOMAIN + 'GET_PENDING_SUCCESS',
  GET_PENDING_FAILURE: _DOMAIN + 'GET_PENDING_FAILURE',
  GET_REJECTED_INIT: _DOMAIN + 'GET_REJECTED_INIT',
  GET_REJECTED_SUCCESS: _DOMAIN + 'GET_REJECTED_SUCCESS',
  GET_REJECTED_FAILURE: _DOMAIN + 'GET_REJECTED_FAILURE',
  GET_DETACHED_INIT: _DOMAIN + 'GET_DETACHED_INIT',
  GET_DETACHED_SUCCESS: _DOMAIN + 'GET_DETACHED_SUCCESS',
  GET_DETACHED_FAILURE: _DOMAIN + 'GET_DETACHED_FAILURE',
  RELOAD_PENDING_INIT: _DOMAIN + 'RELOAD_PENDING_INIT',
  RELOAD_PENDING_SUCCESS: _DOMAIN + 'RELOAD_PENDING_SUCCESS',
  RELOAD_PENDING_FAILURE: _DOMAIN + 'RELOAD_PENDING_FAILURE',
  RELOAD_REJECTED_INIT: _DOMAIN + 'RELOAD_REJECTED_INIT',
  RELOAD_REJECTED_SUCCESS: _DOMAIN + 'RELOAD_REJECTED_SUCCESS',
  RELOAD_REJECTED_FAILURE: _DOMAIN + 'RELOAD_REJECTED_FAILURE',
  RELOAD_DETACHED_INIT: _DOMAIN + 'RELOAD_DETACHED_INIT',
  RELOAD_DETACHED_SUCCESS: _DOMAIN + 'RELOAD_DETACHED_SUCCESS',
  RELOAD_DETACHED_FAILURE: _DOMAIN + 'RELOAD_DETACHED_FAILURE',
  ATTACH_ITEM_START: _DOMAIN + 'ATTACH_ITEM_START',
  ATTACH_ITEM_SUCCESS: _DOMAIN + 'ATTACH_ITEM_SUCCESS',
  ATTACH_ITEM_FAILURE: _DOMAIN + 'ATTACH_ITEM_FAILURE',
  ON_BLUR: _DOMAIN + 'ON_BLUR',
  SELECT_MENU: _DOMAIN + 'SELECT_MENU'
};